<div class="mb-3 mb-5 loginBox">
  @if (type === 'manual') {
    @if (error) {
      <ngb-alert type="danger" [dismissible]="false">{{ error }}</ngb-alert>
    }
    @if (message) {
      <ngb-alert type="success" [dismissible]="false">{{
        message
      }}</ngb-alert>
    }
    @if (!message) {
      <label><b>{{ "USERNAME" | translate }}</b></label>
      <input type="text" class="form-control" [(ngModel)]="username" />
    }
    @if (!resetted) {
      <button
        class="btn btn-primary mt-2"
        (click)="resetPassword()"
        [disabled]="!username.length"
        >
        {{ "CONFIRM" | translate }}
      </button>
    }
  }
  @if (type === 'verify' && username) {
    <h4>{{ username }}</h4>
    <app-change-password-container
      #passwordContainer
      [hideCurrentPassword]="true"
    ></app-change-password-container>
    @if (!resetted) {
      <button
        class="btn btn-primary mt-2"
        (click)="sendNewPassword($event)"
        [disabled]="!passwordContainer.checkPasswordRequirements()"
        >
        {{ "CONFIRM" | translate }}
      </button>
    }
  }
  @if (type === 'verify' && error) {
    <ngb-alert type="danger" [dismissible]="false">{{ error }}</ngb-alert>
  }
  @if (type === 'verify_complete') {
    <h4>{{ username }}</h4>
    <ngb-alert type="success" [dismissible]="false">{{
      "PASSWORD_RESETTED" | translate
    }}</ngb-alert>
  }
</div>
<p
  (click)="back.next(true)"
  [routerLink]="'/login'"
  class="btn text-md-primary text-sm-white forgot btn-link ps-0"
  >
  {{ "BACK_TO_LOGIN" | translate }}
</p>
